import { Component, HostListener, OnInit } from '@angular/core';
import { HeaderService } from '@app/service/header/header.service';
import { StateService, ZaverProduct } from '@app/service/state/state.service';
import {
  SelectAccountData,
  UserService,
} from '@app/service/user-service/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { Subscription } from 'rxjs';
import { QueryParamsService } from '@app/service/query-params/query-params.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SeRoute } from '@assets/val/route-constants';
import { SelectorItem } from '@app/component/selector/selector.component';
import { ValuePipe } from '@app/shared/pipe/value.pipe';

@Component({
  selector: 'vendor-flow',
  templateUrl: './vendor-flow.component.html',
  styleUrls: ['../../page-shared.css', './vendor-flow.component.scss'],
})
export class VendorFlowComponent extends RouteComponent implements OnInit {
  constructor(
    private userService: UserService,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected router: Router,
    protected route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private queryParamsService: QueryParamsService,
    private valuePipe: ValuePipe
  ) {
    super(router, route, stateService, headerService);
  }

  useIframe: boolean;
  loading: boolean = true;
  trustlyUrl: any = false;
  pollingSubscription: Subscription;
  ZAVERPRODUCT = ZaverProduct;
  selectorItems: SelectorItem[] = null;
  modalActive: boolean = false;
  isFocused: boolean = true;
  isIframeFinished: boolean = false;

  @HostListener('document:visibilitychange', ['$event'])
  onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.isFocused = true;

      if (this.isIframeFinished) {
        this.stateService.syncRouteWithState();
      } else {
        console.log("Iframe flow is not concluded, not attempting anything yet.");
      }
    } else {
      this.isFocused = false;
    }
  }

  @HostListener('window:message', ['$event'])
  navigateListener($event: MessageEvent<any>) {
    if (($event as any).data.success) {
      this.isIframeFinished = true;
      if (this.isFocused) {
        this.navigate();
      } else {
        console.log("Received navigation parameters but the focus is not on! Will only try to navigate if the focus comes back.")
      }
    }
  }

  async ngOnInit(): Promise<void> {
    const id = this.queryParamsService.getQueryParams().id;
    const selectAccountData: SelectAccountData = {
      failEndpoint: `${window.location.origin}/${SeRoute.ERROR}?id=${id}`,
      successEndpoint: `${window.location.origin}/${SeRoute.TRANSITION}?id=${id}`,
    };

    const selectAccountUrl = (
      await this.userService.selectAccount(selectAccountData).toPromise()
    ).selectAccountUrl;

    this.trustlyUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(selectAccountUrl);

    this.useIframe = true;
    this.selectorItems = [
      {
        tab: 'Ditt köp',
        title: 'Sammanfattning',
        descriptions: [{ text: this.state.paymentInformation.description }],
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: `Totalbelopp inkl. moms: ${this.valuePipe.transform(
          this.state.totalCheckoutValue
        )}`,
      },
    ];

    this.loading = false;
  }

  toggleModal(): void {
    this.modalActive = !this.modalActive;
  }
}
